import React from 'react'
import { Link, graphql, StaticQuery } from "gatsby"


export default function Footer({ data }) {

  const articlesQuery = graphql`
    query RecentPosts {
      allMarkdownRemark(sort: {fields: frontmatter___createdAt, order: DESC}) {
        edges {
          node {
            frontmatter {
              path
              title
            }
          }
        }
      }
    } 
  `

  const Component = ({ data }) => {
    const articles = data.allMarkdownRemark.edges

    return (
      <footer className="footer">
        <div className="navigate">
          <h4 className="categoryTitle">Parcourir le site</h4>
          <nav className="links">
            <Link to="/" className="link">Accueil</Link>
            <Link to="/about" className="link">A propos</Link>
            <Link to="/projects" className="link">Réalisations</Link>
            <Link to="/articles" className="link">Articles</Link>
            <Link to="/contact" className="link">Contact</Link>
          </nav>
        </div>
        <div className="recentArticles">
          <h4 className="categoryTitle">Mes derniers articles</h4>
          <ul className="links">
            {Array(3).fill("").map((_, i) => (
              <Link 
                to={articles[i].node.frontmatter.path} 
                className="link"
                key={i}
              >
                {articles[i].node.frontmatter.title}
              </Link>
            ))}
          </ul>
        </div>
      </footer>
    )
  }

  return (
    <>
      <StaticQuery 
        query={articlesQuery}
        render={data => <Component data={data} />}
      />
    </>
  )
}